/**
 * Volume Benefits Checkmark Updater
 * Updates green checkmarks for volume benefits based on total cart quantity
 */
class VolumeBenefitsUpdater {
  constructor() {
    this.cartUpdateUnsubscriber = undefined;
    this.updateTimeout = null;
    this.cachedCartQuantity = null;
    this.init();
  }

  init() {
    this.updateCheckmarks();

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event?.cartData?.items) {
          this.cachedCartQuantity = this.sumCartItems(event.cartData);
          this.scheduleUpdate(this.cachedCartQuantity);
          return;
        }
        this.scheduleUpdate();
      });
    }
  }

  scheduleUpdate(totalQuantity = null) {
    if (this.updateTimeout) {
      clearTimeout(this.updateTimeout);
    }

    this.updateTimeout = setTimeout(() => {
      this.updateTimeout = null;
      if (totalQuantity !== null) {
        this.updateCheckmarks(totalQuantity);
      } else {
        this.fetchCartAndUpdate();
      }
    }, 150);
  }

  sumCartItems(cartData) {
    if (!cartData?.items || !Array.isArray(cartData.items)) return 0;

    return cartData.items.reduce((sum, item) => {
      return sum + (parseInt(item.quantity, 10) || 0);
    }, 0);
  }

  async fetchCartAndUpdate() {
    if (this.cachedCartQuantity !== null) {
      this.updateCheckmarks(this.cachedCartQuantity);
      return;
    }

    try {
      const response = await fetch(`${routes.cart_url}.js`);
      if (response.ok) {
        const cartData = await response.json();
        this.cachedCartQuantity = this.sumCartItems(cartData);
        this.updateCheckmarks(this.cachedCartQuantity);
      }
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  }

  updateCheckmarks(cartItemCount = null) {
    if (cartItemCount === null) {
      let totalQuantity = 0;
      const quantityInputs = document.querySelectorAll(
        'cart-items quantity-input input, cart-drawer-items quantity-input input, quantity-input input[data-cart-quantity]'
      );

      quantityInputs.forEach((input) => {
        totalQuantity += parseInt(input.value, 10) || 0;
      });

      if (totalQuantity === 0) {
        const cartCountElement = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
        if (cartCountElement) {
          totalQuantity = parseInt(cartCountElement.textContent.trim(), 10) || 0;
        }
      }

      cartItemCount = totalQuantity;

      if (cartItemCount === 0) {
        this.fetchCartAndUpdate();
        return;
      }
    }

    document.querySelectorAll('.volume-benefits-container').forEach((container) => {
      container.querySelectorAll('.volume-benefit').forEach((benefit) => {
        const threshold = parseInt(benefit.getAttribute('data-threshold'), 10);
        const checkmark = benefit.querySelector('.checkmark');

        if (!checkmark || Number.isNaN(threshold)) return;

        const isActive = cartItemCount >= threshold;
        const nextMarkup = isActive ? '✓' : '';
        checkmark.classList.toggle('active', isActive);
        if (checkmark.innerHTML !== nextMarkup) {
          checkmark.innerHTML = nextMarkup;
        }
      });
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new VolumeBenefitsUpdater();
  });
} else {
  new VolumeBenefitsUpdater();
}
